export default __webpack_public_path__ + "static/liptonbanner.jpg-265ae965c37cd77fca10d7c793d6190c.jpg";